import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getArticleImageUrl } from '../utils/image-url.util';

export interface PublicArticle {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  cover_image: string | null;
  category: string | null;
  author_name: string | null;
  published_at: string;
  reading_minutes: number;
  content?: string;
}

export interface ArticlePage {
  data: PublicArticle[];
  meta: { page: number; limit: number; total: number; total_pages: number };
}

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  constructor(private http: HttpClient) {}

  /** Published articles only, newest first. */
  getPublished(options: { page?: number; limit?: number; category?: string } = {}): Observable<ArticlePage> {
    let params = new HttpParams()
      .set('page', String(options.page ?? 1))
      .set('limit', String(options.limit ?? 9));
    if (options.category) {
      params = params.set('category', options.category);
    }
    return this.http.get<ArticlePage>(`/api/articles/published`, { params });
  }

  getBySlug(slug: string): Observable<{ data: PublicArticle }> {
    return this.http.get<{ data: PublicArticle }>(`/api/articles/published/${encodeURIComponent(slug)}`);
  }

  coverUrl(article: PublicArticle): string {
    return article.cover_image ? getArticleImageUrl(article.cover_image) : 'assets/img/placeholder.jpg';
  }

  formatDate(value: string): string {
    return new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  }
}
